<mat-form-field celum-form-field [size]="formFieldSize" class="lookup-area_lookup" appearance="outline">
  <input
    matInput
    autocomplete="off"
    data-test-lookup-input-field
    [formControl]="valueControl"
    [placeholder]="placeholder | translate"
    (keydown)="onKeyDown($event)"
    (focusin)="onFocus(true)"
    (focusout)="onFocus(false)" />
  @if (valueControl?.value.length === 0 && iconPosition === 'left') {
    <celum-icon class="lookup-area_icon" matPrefix [configuration]="searchIcon"></celum-icon>
  } @else if (valueControl?.value.length === 0 && iconPosition === 'right') {
    <celum-icon class="lookup-area_icon" matSuffix [configuration]="searchIcon"></celum-icon>
  }
  @if (valueControl?.value.length > 0) {
    <celum-icon
      class="lookup-area_icon lookup-area_cancel-icon"
      data-test-lookup-cancel-icon
      matSuffix
      [configuration]="cancelIcon"
      [matTooltip]="'COMMON.REMOVE' | translate"
      (click)="clear()"></celum-icon>
  }
  <ng-content select="[right-content]" matSuffix></ng-content>
</mat-form-field>
